module.exports = __webpack_public_path__ + "img/pic3@2x.063bc6f8.png";